"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var helper_1 = require("./helper");
// import { CabinsCabin as Cabin } from './state'
// returns the last request identifier for "findCabinCategories" call
function lastFindCabinCategoriesRequest(state) {
    return state.loadingCabinCategories;
}
function lastFindCabinsRequest(state) {
    return state.loadingCabins;
}
function lastFindWishCabinRequest(state) {
    return state.loadingWishCabin;
}
// return the currently selected cabinCategory
function selectedCabinCategory(state, getters) {
    var cabinCategory = lodash_1.find(getters['allMainCabinCategories'], {
        mainCode: state.cabinCategory,
    });
    if (state.activeAdditionalCategory === 'NONE') {
        return cabinCategory || null;
    }
    if (state.activeAdditionalCategory === 'VARIOAI') {
        return lodash_1.find(cabinCategory.varioAICategories, { code: cabinCategory.code }) || null;
    }
    if (state.activeAdditionalCategory === 'PREMIUM') {
        var premiumCode = currentSelectionCategoryConfiguration(state).subCategory;
        return lodash_1.find(cabinCategory.premiumCategories, { code: premiumCode }) || null;
    }
    if (state.activeAdditionalCategory === 'PREMIUMAI') {
        var premiumAICode = currentSelectionCategoryConfiguration(state)
            .subCategory;
        return lodash_1.find(cabinCategory.premiumAICategories, { code: premiumAICode }) || null;
    }
}
// shorthand to directly get the code of the currently selected cabinCategory
function selectedCabinCategoryCode(state, getters) {
    if (!state.cabinCategory) {
        return null;
    }
    var cabinCategory = getters['selectedCabinCategory'];
    if (!cabinCategory) {
        return null;
    }
    return cabinCategory.code;
}
function selectedMainCabinCategory(state, getters) {
    var cabinCategory = lodash_1.find(getters['allMainCabinCategories'], {
        mainCode: state.cabinCategory,
    });
    if (!state.cabinCategory || !cabinCategory) {
        return null;
    }
    return cabinCategory;
}
function selectedMainCabinCategoryCode(state) {
    if (!state.cabinCategory) {
        return null;
    }
    return state.cabinCategory;
}
// shorthand to directly get the code of the currently selected cabinCategory
function selectedCabinCategoryPrice(state, getters) {
    if (state.cabinCategory && getters['selectedCabinCategory'] && !getters['isVarioAISelected']) {
        var cabinCategory = getters['selectedCabinCategory'];
        return cabinCategory.price;
    }
    else if (getters['selectedMainCabinCategory'] &&
        getters['isVarioAISelected']) {
        var mainCabinCategory = getters['selectedMainCabinCategory'];
        return mainCabinCategory.cheapestVarioAIprice;
    }
    else if (getters['selectedMainCabinCategory'] &&
        getters['isPremiumSelected']) {
        var mainCabinCategory = getters['selectedMainCabinCategory'];
        return mainCabinCategory.cheapestPremiumPrice;
    }
    else if (getters['selectedMainCabinCategory'] &&
        getters['isPremiumAISelected']) {
        var mainCabinCategory = getters['selectedMainCabinCategory'];
        return mainCabinCategory.cheapestPremiumAIPrice;
    }
    return 0;
}
// return all cabinCategories, available or not
// TODO: determine if this should also show premium cabins...
function allMainCabinCategories(state) {
    return state.cabinCategories;
}
// return all cabinCategories that are available for booking
// TODO: determine if this should also show premium cabins...
function availableMainCabinCategories(state) {
    return lodash_1.filter(state.cabinCategories, function (cabin) {
        return (cabin.available === true ||
            cabin.premiumAvailable === true ||
            cabin.premiumAIAvailable === true);
    });
}
// vario more or less...
function availableNormalCabinCategories(state) {
    return lodash_1.filter(state.cabinCategories, function (cabin) {
        return cabin.available === true;
    });
}
// return the cheapest available CabinCategory
// NOTE: This only returns mainCategories
function cheapestCabinCategory(state) {
    return lodash_1.first(availableMainCabinCategories(state));
}
// return the cheapest available CabinCategory
// NOTE: This only returns mainCategories
function cheapestCabinCategoryCode(state) {
    var cheapest = cheapestCabinCategory(state);
    if (cheapest) {
        return cheapest.code;
    }
    else {
        return null;
    }
}
function getAvailableCabinCategories(state) {
    return state.availableCabinCategories;
}
// return the price of the cheapest available CabinCategory
// NOTE: This only returns mainCategories
function cheapestCabinCategoryPrice(state) {
    var cheapest = cheapestCabinCategory(state);
    if (cheapest) {
        var cheapestNormalPrice = cheapest.available
            ? cheapest.price
            : Number.MAX_VALUE;
        var cheapestSupportPrice = Number.MAX_VALUE;
        if (state.priceModelSupportsPremium) {
            var cheapestSupportPremiumPrice = cheapest.premiumAvailable
                ? cheapest.cheapestPremiumPrice
                : Number.MAX_VALUE;
            var cheapestSupportPremiumAIPrice = cheapest.premiumAIAvailable
                ? cheapest.cheapestPremiumAIPrice
                : Number.MAX_VALUE;
            cheapestSupportPrice = Math.min(cheapestSupportPremiumPrice, cheapestSupportPremiumAIPrice);
        }
        var cheapestPrice = Math.min(cheapestNormalPrice, cheapestSupportPrice);
        if (cheapestPrice !== Number.MAX_VALUE) {
            return cheapestPrice;
        }
    }
    return 0;
}
// is the currently selected cabinCategory available
// NOTE: This also works for premiumCategories
// TODO: used as valid getter, need a expanded one
function selectedCabinCategoryIsValid(state, getters) {
    if (!state.cabinCategory) {
        return false;
    }
    // console.log('state.cabinCategory', state.cabinCategory)
    var cabinCategory = getters['selectedCabinCategory'];
    // console.log('cabinCategory', JSON.stringify(cabinCategory))
    if (!cabinCategory || !cabinCategory.available) {
        return false;
    }
    return true;
}
function valid(_, getters) {
    return (getters['selectedCabinCategoryIsValid'] &&
        getters['selectedCabinIsValid']);
}
function selectedCabinIsValid(state, getters) {
    if (state.activeAdditionalCategory === 'NONE' || state.activeAdditionalCategory === 'VARIOAI') {
        return true;
    }
    var currentCabin = getters['currentSelectionCabin'];
    if (currentCabin) {
        var other = getters['selectedByOtherStores'];
        if (other.indexOf(currentCabin.id) !== -1) {
            return false;
        }
        return true;
    }
    return false;
}
function currentSelectionCategoryConfiguration(state) {
    return helper_1.default.getCurrentSelectionConfiguration(state);
}
function currentSelectionCategoryStep(state) {
    var step = helper_1.default.getCurrentSelectionConfiguration(state);
    return step ? step.currentStep : 'SC';
}
function currentSelectionCabin(state, getters) {
    var currenPremium = helper_1.default.getCurrentSelectionConfiguration(state);
    if (!currenPremium) {
        return null;
    }
    var cabinNumber = currenPremium.cabin;
    var cabins = getters['currentCabinsOnDeck'];
    return lodash_1.find(cabins, { id: cabinNumber }) || null;
}
function currentSelectionCabinNumber(_, getters) {
    var cabin = getters['currentSelectionCabin'];
    return cabin ? cabin.id : null;
}
function currentSelectionCabins(state, getters) {
    var currentSelection = getters['currentSelectionCategoryConfiguration'];
    if (!currentSelection) {
        return [];
    }
    var cabinWrapper = lodash_1.find(state.cabins, {
        category: currentSelection.subCategory,
    });
    if (cabinWrapper) {
        return cabinWrapper.cabins;
    }
    return [];
}
// returns the main cabin categories of the current ship
function mainCabinCategories(state) {
    return state.mainCabinCategories;
}
function decksOnShip(state, getters) {
    var currentSelection = getters['currentSelectionCategoryConfiguration'];
    if (!currentSelection) {
        return [];
    }
    var cabinWrapper = lodash_1.find(state.cabins, {
        category: currentSelection.subCategory,
    });
    if (cabinWrapper) {
        return cabinWrapper.decks;
    }
    return [];
}
function decks(state) {
    return state.decks;
}
function currentDeck(_state, getters) {
    var currentSelection = getters['currentSelectionCategoryConfiguration'];
    return currentSelection ? currentSelection.deck : null;
}
function currentSection(_state, getters) {
    var currentSelection = getters['currentSelectionCategoryConfiguration'];
    return currentSelection ? currentSelection.shipSection : null;
}
// only getter which maps used cabins
function currentCabinsOnDeck(_state, getters) {
    var cabins = getters['currentCabinsOnSection'];
    var selectedByOtherStores = getters['selectedByOtherStores'];
    var deck = getters['currentDeck'];
    cabins = lodash_1.filter(cabins, { deck: deck });
    cabins = lodash_1.map(lodash_1.cloneDeep(cabins), function (cabin) {
        if (selectedByOtherStores.indexOf(cabin.id) !== -1) {
            cabin.selectedByOtherStore = true;
        }
        else {
            cabin.selectedByOtherStore = false;
        }
        return cabin;
    });
    return cabins;
}
function currentCabinsOnSection(_state, getters) {
    var cabins = getters['currentSelectionCabins'];
    var section = getters['currentSection'];
    cabins = lodash_1.filter(cabins, { position: section });
    return cabins;
}
function currentDecks(_state, getters) {
    var cabins = getters['currentCabinsOnSection'];
    var decks = getters['decksOnShip'];
    var availableDecks = lodash_1.uniq(lodash_1.reduce(cabins, function (deck, cabin) {
        deck.push(cabin.deck);
        return deck;
    }, []));
    decks = lodash_1.map(decks, function (deck) {
        var deckInfo = lodash_1.cloneDeep(deck);
        deckInfo.unavailable =
            availableDecks.indexOf(deckInfo.deck) > -1 ? false : true;
        return deckInfo;
    });
    return lodash_1.sortBy(decks, 'deck');
}
function currentAvailableDecks(_state, getters) {
    var decks = getters['currentDecks'];
    return lodash_1.filter(decks, function (deck) {
        return !deck.unavailable;
    });
}
function currentSections(_state, getters) {
    var cabins = getters['currentSelectionCabins'];
    var sections = {
        vorne: false,
        hinten: false,
        mittig: false,
    };
    sections = lodash_1.reduce(cabins, function (sections, cabin) {
        sections[cabin.position] = true;
        return sections;
    }, sections);
    return sections;
}
// return all premium cabinCategories that are available for booking for the current maincabincategory
function currentAvailablePremiumCabinCategories(_state, getters) {
    var cabinCategory = getters['selectedMainCabinCategory'];
    if (cabinCategory && cabinCategory.premiumCategories) {
        return lodash_1.filter(cabinCategory.premiumCategories, function (cabin) {
            return cabin.available === true;
        });
    }
    return [];
}
// return all premium cabinCategories that are available for booking for the current maincabincategory
function currentAvailablePremiumAICabinCategories(_state, getters) {
    var cabinCategory = getters['selectedMainCabinCategory'];
    if (cabinCategory && cabinCategory.premiumAICategories) {
        return lodash_1.filter(cabinCategory.premiumAICategories, function (cabin) {
            return cabin.available === true;
        });
    }
    return [];
}
// return all premiumAI cabinCategories that are available for booking for the current maincabincategory
function currentSelectionCabinCategories(state, getters) {
    var cabinCategory = getters['selectedMainCabinCategory'];
    if (state.activeAdditionalCategory === 'PREMIUM') {
        if (cabinCategory && cabinCategory.premiumCategories) {
            return cabinCategory.premiumCategories;
        }
    }
    else if (state.activeAdditionalCategory === 'PREMIUMAI') {
        if (cabinCategory && cabinCategory.premiumAICategories) {
            return cabinCategory.premiumAICategories;
        }
    }
    return [];
}
// return all premiumn cabinCategories that are available for booking
function availablePremiumCabinCategories(_, getters) {
    var availables = getters['premiumCabinCategories'];
    availables = lodash_1.filter(availables, function (category) {
        return category.available === true;
    });
    return availables;
}
// return all premiumn cabinCategories that are available for booking
function availablePremiumAICabinCategories(_, getters) {
    var availables = getters['premiumAICabinCategories'];
    availables = lodash_1.filter(availables, function (category) {
        return category.available === true;
    });
    return availables;
}
// return all premium cabinCategories that are available for booking
function premiumCabinCategories(_, getters) {
    var availables = [];
    for (var _i = 0, _a = getters['allMainCabinCategories']; _i < _a.length; _i++) {
        var cat = _a[_i];
        if (!cat.premiumCategories) {
            continue;
        }
        for (var _b = 0, _c = cat.premiumCategories; _b < _c.length; _b++) {
            var pCat = _c[_b];
            availables.push(pCat);
        }
    }
    return availables;
}
// return all premiumAI cabinCategories that are available for booking
function premiumAICabinCategories(_, getters) {
    var availables = [];
    for (var _i = 0, _a = getters['allMainCabinCategories']; _i < _a.length; _i++) {
        var cat = _a[_i];
        if (!cat.premiumAICategories) {
            continue;
        }
        for (var _b = 0, _c = cat.premiumAICategories; _b < _c.length; _b++) {
            var pCat = _c[_b];
            availables.push(pCat);
        }
    }
    return availables;
}
// return the cheapest available premium CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumCabinCategory(_state, getters) {
    var cabinCategories = getters['currentAvailablePremiumCabinCategories'];
    if (!cabinCategories || !cabinCategories.length) {
        return null;
    }
    return lodash_1.first(cabinCategories);
}
// return the cheapest available premiumAI CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumAICabinCategory(_state, getters) {
    var cabinCategories = getters['currentAvailablePremiumAICabinCategories'];
    if (!cabinCategories || !cabinCategories.length) {
        return null;
    }
    return lodash_1.first(cabinCategories);
}
// return the cheapest available premium CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumCabinCategoryCode(_state, getters) {
    var cheapest = getters['cheapestPremiumCabinCategory'];
    if (cheapest) {
        return cheapest.code;
    }
    else {
        return null;
    }
}
// return the cheapest available premiumAI CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumAICabinCategoryCode(_state, getters) {
    var cheapest = getters['cheapestPremiumAICabinCategory'];
    if (cheapest) {
        return cheapest.code;
    }
    else {
        return null;
    }
}
// return the price of the cheapest available premium CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumCabinCategoryPrice(_state, getters) {
    var cheapest = getters['cheapestPremiumCabinCategory'];
    if (cheapest) {
        return cheapest.price;
    }
    else {
        return 0;
    }
}
// return the price of the cheapest available premiumAI CabinCategory
// NOTE: This only returns mainCategories
function cheapestPremiumAICabinCategoryPrice(_state, getters) {
    var cheapest = getters['cheapestPremiumAICabinCategory'];
    if (cheapest) {
        return cheapest.price;
    }
    else {
        return 0;
    }
}
function isPremiumSelected(state) {
    return state.activeAdditionalCategory === 'PREMIUM';
}
function isPremiumAISelected(state) {
    return state.activeAdditionalCategory === 'PREMIUMAI';
}
function isVarioAISelected(state) {
    return state.activeAdditionalCategory === 'VARIOAI';
}
function isPremiumCabinCategory(_state, getters) {
    return function (code) {
        return !!lodash_1.find(getters['premiumCabinCategories'], { code: code });
    };
}
function isPremiumAICabinCategory(_state, getters) {
    return function (code) {
        return !!lodash_1.find(getters['premiumAICabinCategories'], { code: code });
    };
}
function mainCodeForCabinCategoryCode(_state, getters) {
    return function (code) {
        var cabinCategory = lodash_1.find(getters['premiumCabinCategories'], { code: code });
        if (!cabinCategory) {
            cabinCategory = lodash_1.find(getters['allMainCabinCategories'], { code: code });
        }
        return cabinCategory ? cabinCategory.mainCode : null;
    };
}
function loadingRequiredCabinStatus(state) {
    return state.loadingRequiredCabin;
}
function isPremiumSupported(state) {
    return state.priceModelSupportsPremium;
}
function isVarioAISupoorted(state) {
    return state.varioAISupport;
}
function amenities(_state, getters) {
    var currentCabinCategory = getters['selectedCabinCategory'];
    if (currentCabinCategory) {
        return currentCabinCategory.amenities;
    }
    var cheapestCabinCategory = getters['cheapestCabinCategory'];
    if (cheapestCabinCategory) {
        return cheapestCabinCategory.amenities;
    }
    return [];
}
function state(state) {
    return state;
}
function selectedByOtherStores(state) {
    return state.selectedByOtherStores;
}
// return the current priceDiffer item
function currentPriceDiffer(state, getters) {
    var selectedCabCatCode = getters['selectedCabinCategoryCode'];
    var priceDiffer = lodash_1.find(state.priceDiffers, function (item) {
        return selectedCabCatCode === item.cabinCategoryCode;
    });
    return priceDiffer ? priceDiffer : null;
}
function fetchCategoriesDone(state) {
    return state.fetchCategoriesDone;
}
function showLowCabinInfo(state) {
    return (currentSelectionCategoryConfiguration(state) || { lowCabinInfo: false }).lowCabinInfo;
}
// export everything compliant to the vuex specification for getters
exports.default = {
    allMainCabinCategories: allMainCabinCategories,
    amenities: amenities,
    availableMainCabinCategories: availableMainCabinCategories,
    availableNormalCabinCategories: availableNormalCabinCategories,
    availablePremiumAICabinCategories: availablePremiumAICabinCategories,
    availablePremiumCabinCategories: availablePremiumCabinCategories,
    cheapestCabinCategory: cheapestCabinCategory,
    cheapestCabinCategoryCode: cheapestCabinCategoryCode,
    cheapestCabinCategoryPrice: cheapestCabinCategoryPrice,
    cheapestPremiumAICabinCategory: cheapestPremiumAICabinCategory,
    cheapestPremiumAICabinCategoryCode: cheapestPremiumAICabinCategoryCode,
    cheapestPremiumAICabinCategoryPrice: cheapestPremiumAICabinCategoryPrice,
    cheapestPremiumCabinCategory: cheapestPremiumCabinCategory,
    cheapestPremiumCabinCategoryCode: cheapestPremiumCabinCategoryCode,
    cheapestPremiumCabinCategoryPrice: cheapestPremiumCabinCategoryPrice,
    currentAvailableDecks: currentAvailableDecks,
    currentAvailablePremiumAICabinCategories: currentAvailablePremiumAICabinCategories,
    currentAvailablePremiumCabinCategories: currentAvailablePremiumCabinCategories,
    currentCabinsOnDeck: currentCabinsOnDeck,
    currentCabinsOnSection: currentCabinsOnSection,
    currentDeck: currentDeck,
    currentDecks: currentDecks,
    currentPriceDiffer: currentPriceDiffer,
    currentSection: currentSection,
    currentSections: currentSections,
    currentSelectionCabin: currentSelectionCabin,
    currentSelectionCabinCategories: currentSelectionCabinCategories,
    currentSelectionCabinNumber: currentSelectionCabinNumber,
    currentSelectionCabins: currentSelectionCabins,
    currentSelectionCategoryConfiguration: currentSelectionCategoryConfiguration,
    currentSelectionCategoryStep: currentSelectionCategoryStep,
    decks: decks,
    decksOnShip: decksOnShip,
    fetchCategoriesDone: fetchCategoriesDone,
    getAvailableCabinCategories: getAvailableCabinCategories,
    isPremiumAICabinCategory: isPremiumAICabinCategory,
    isPremiumAISelected: isPremiumAISelected,
    isPremiumCabinCategory: isPremiumCabinCategory,
    isPremiumSelected: isPremiumSelected,
    isPremiumSupported: isPremiumSupported,
    lastFindCabinCategoriesRequest: lastFindCabinCategoriesRequest,
    lastFindCabinsRequest: lastFindCabinsRequest,
    lastFindWishCabinRequest: lastFindWishCabinRequest,
    loadingRequiredCabinStatus: loadingRequiredCabinStatus,
    mainCabinCategories: mainCabinCategories,
    mainCodeForCabinCategoryCode: mainCodeForCabinCategoryCode,
    premiumAICabinCategories: premiumAICabinCategories,
    premiumCabinCategories: premiumCabinCategories,
    selectedCabinCategory: selectedCabinCategory,
    selectedCabinCategoryCode: selectedCabinCategoryCode,
    selectedCabinCategoryIsValid: selectedCabinCategoryIsValid,
    selectedCabinCategoryPrice: selectedCabinCategoryPrice,
    selectedMainCabinCategory: selectedMainCabinCategory,
    selectedMainCabinCategoryCode: selectedMainCabinCategoryCode,
    selectedCabinIsValid: selectedCabinIsValid,
    selectedByOtherStores: selectedByOtherStores,
    showLowCabinInfo: showLowCabinInfo,
    state: state,
    valid: valid,
    isVarioAISupoorted: isVarioAISupoorted,
    isVarioAISelected: isVarioAISelected
};
//# sourceMappingURL=getters.js.map